import { useState, useEffect } from "react";
import { StorageHelper } from "../helpers/storage-helper";
import { AuthClient } from "../api-client/auth.client";

// カスタムフック
export function useToken(): [string | null, (token: string | null) => void] {
  // Tokenを状態として持つ
  const [token, setTokenState] = useState<string | null>(
    StorageHelper.getToken(),
  );

  // AuthClientのインスタンスを作成
  const authClient = new AuthClient();

  // Tokenを設定する関数
  const setToken = (newToken: string | null) => {
    if (newToken === null) {
      StorageHelper.setToken(""); // Tokenを削除
    } else {
      StorageHelper.setToken(newToken);
    }
    setTokenState(newToken); // 状態に更新
  };

  // Tokenが変更されるたびにAuthClientのvalidメソッドを使って検証する
  useEffect(() => {
    if (token) {
      (async () => {
        try {
          const validationResponse = await authClient.valid(); // AuthClientのvalidメソッドを使用
          if (!validationResponse.valid) {
            console.error("Token validation failed:", validationResponse.error);
            setToken(null); // トークン無効の場合は削除
          }
        } catch (error) {
          console.error("Error validating token:", error);
          setToken(null); // エラーハンドリング
        }
      })();
    }
  }, [token]); // トークン変更時にAPIをコール

  return [token, setToken];
}